import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lol",
  "use": "lol-usage",
  "viewBox": "0 0 33 35",
  "content": "<symbol viewBox=\"0 0 33 35\" xmlns=\"http://www.w3.org/2000/svg\" id=\"lol\"><path d=\"M1.5 0h19l-4.25 3.4a2 2 0 0 0-.75 1.561V28a1 1 0 0 0 1 1h3.74a12 12 0 0 0 7.567-2.687L32.5 22.5v.105a16 16 0 0 1-1.379 6.498L28.5 35H0l5.72-4.4a2 2 0 0 0 .78-1.585V4.961A2 2 0 0 0 5.75 3.4L1.5 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol